import { useQuizContext } from "@/pages/quiz/context";
import { ProgressBarV1 } from "@/components/ProgressBarV1";
import { clsxm } from "@/utils/clsxm";
import { getSections } from "@/pages/quiz/base/components/progressHeaderV1/common";
import { CompleteLabel } from "@/pages/quiz/base/components/progressHeaderV1/components/CompleteLabel";

interface IProps {
  hideProgressBar?: boolean;
}

const ProgressHeaderV1 = ({ hideProgressBar = false }: IProps) => {
  const { questions, selectedQuestionIdx } = useQuizContext();

  if (hideProgressBar) {
    return null;
  }

  const questionsAmount = questions?.length ?? 0;

  const sections = getSections(questionsAmount);

  const currentSectionIndex = sections.findIndex(
    (section) => selectedQuestionIdx < section.startIdx + section.count
  );
  const currentSection = sections[currentSectionIndex];

  return (
    <div
      className={clsxm(
        "w-full sm:w-618 mx-auto my-6 max-w-[calc(100%-32px)] sm:my-10 space-y-3"
      )}
    >
      <div className="text-main-button-v2 w-full flex justify-center items-stretch gap-3 text-sm sm:text-base">
        <div className="font-bold">{currentSection.label}</div>

        <CompleteLabel currentSection={currentSection} />
      </div>

      {!!questionsAmount && (
        <div className="flex w-full gap-2 items-center mt-4 mb-5 sm:mb-7">
          {sections.map((section) => {
            const start = section.startIdx;
            const end = section.startIdx + section.count;
            const isCurrent =
              selectedQuestionIdx >= start && selectedQuestionIdx < end;
            const isCompleted = selectedQuestionIdx >= end;

            const answeredInSection = isCurrent
              ? selectedQuestionIdx - start
              : isCompleted
              ? section.count
              : 0;

            const percent = Math.floor(
              (answeredInSection / section.count) * 100
            );

            return (
              <div
                key={section.key}
                className={clsxm(
                  "min-w-8 sm:min-w-10",
                  isCurrent && "flex-1",
                  isCompleted && "min-w-4 sm:min-w-4"
                )}
              >
                <ProgressBarV1
                  progress={percent}
                  isComplete={isCompleted}
                  isCurrent={isCurrent}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export { ProgressHeaderV1 };
